const FLAG_PREFIX = 'feature_flag_';

export function getFeatureFlag(name: string, defaultValue = false): boolean {
    const storageKey = FLAG_PREFIX + name;

    try {
        const paramRawValue = new URLSearchParams(window.location.search).get(name);
        const paramValue =
            paramRawValue === 'true' || paramRawValue === 'false'
                ? JSON.parse(paramRawValue)
                : null;

        const storedJson = window?.localStorage?.getItem(storageKey);
        const storedValue = storedJson ? JSON.parse(storedJson) : null;

        return paramValue ?? storedValue ?? defaultValue;
    } catch (err) {
        return defaultValue;
    }
}
